export default __webpack_public_path__ + "static/media/TheQuarryMap.bb4a3402.jpg";